import { Component, Input, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "../../common-imports"
import { PolicyFormVersion } from "@app/definitions/types"
import { ApiService } from "@app/services/api.service"
import { ModalService } from "@app/services/modal.service"
import { StoreService } from "@app/services/store.service"
import {
	BtnExtComponent,
	SpinOrContent,
	TableWrapComponent,
} from "@app/utils/utils.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { Row } from "./row.component"
import { Version } from "./version.component"

@Component({
	selector: "versions",
	imports: [
		COMMON_IMPORTS,
		SpinOrContent,
		LangValPipe,
		BtnExtComponent,
		TableWrapComponent,
		Version,
		Row,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./versions.component.html",
})
export class Versions {
	constructor(
		public apiService: ApiService,
		public store: StoreService,
		public modalService: ModalService
	) {}

	@Input() objectRow: any = null
	activeVersion: PolicyFormVersion | null = null
	versions: PolicyFormVersion[] = []
	isLoading: boolean = false
	versionsIsOpen: boolean = true
	isLatestInUse: boolean = false

	async ngOnInit() {
		this.versions = this.store.getSortedVersions(this.objectRow.id)
		if (!this.versions.length) {
			this.activeVersion = new PolicyFormVersion()
			this.activeVersion.policy_form_id = this.objectRow.id
		} else {
			this.isLoading = true
			const res = await this.apiService.post("version_in_use", {
				id: this.versions.at(0)?.id,
			})
			this.isLoading = false
			this.isLatestInUse = res.found
		}
	}
	async createFromLatest() {
		const { item, fields } = await this.apiService.post(
			"create_version_from_latest",
			{
				policy_form_id: this.objectRow.id,
			}
		)
		this.store.addGenItemRow("policy_form_versions", item)
		fields.forEach((field) =>
			this.store.addGenItemRow("policy_form_version_fields", field)
		)

		this.activeVersion = item
		this.versions = [item, ...this.versions]
		this.isLatestInUse = false
		this.modalService.openToast("saved_successfully")
	}
	handleSaveNew(item: PolicyFormVersion) {
		this.versions = [item, ...this.versions]
		this.isLatestInUse = false
	}
}
